// export default function loadDify(token) {
//     if (!token) return

//     // // 避免重复加载
//     // if (document.getElementById(token)) return

//     window.difyChatbotConfig = {
//         token: token,
//         baseUrl: 'http://dify.hyxun.top',
//         inputs: {},
//         systemVariables: {},
//         userVariables: {},
//     }

//     // 脚本
//     const script = document.createElement("script")
//     script.src = "http://dify.hyxun.top/embed.min.js"
//     script.id = token
//     script.defer = true
//     document.body.appendChild(script)

//     // 样式（可选覆盖按钮和窗口）
//     const style = document.createElement("style")
//     style.innerHTML = `
//         #dify-chatbot-bubble-button {
//             background-color: #1C64F2 !important;
//         }
//         #dify-chatbot-bubble-window {
//             width: 24rem !important;
//             height: 40rem !important;
//             right: 80px !important;
//             bottom: 120px !important;
//         }
//     `
//     document.head.appendChild(style)
// }



export default function loadDify(token) {
    console.log(1);
    if (!token) return
    // 1️⃣ 移除旧机器人
    const oldScript = document.querySelector('script[id^="dify-"]')
    if (oldScript) oldScript.remove()

    const oldStyle = document.getElementById('dify-style')
    if (oldStyle) oldStyle.remove()

    const oldButton = document.getElementById('dify-chatbot-bubble-button')
    if (oldButton) oldButton.remove()

    const oldWindow = document.getElementById('dify-chatbot-bubble-window')
    if (oldWindow) oldWindow.remove()

    // 2️⃣ 配置新机器人
    window.difyChatbotConfig = {
        token: token,
        baseUrl: 'https://dify.hyxun.top',
        inputs: {},
        language: 'zh-CN', // ← 这里设置中文
        systemVariables: {},
        userVariables: {},
    }

    // 3️⃣ 插入脚本
    const script = document.createElement("script");
    script.src = "https://dify.hyxun.top/embed.min.js";
    script.id = 'dify-' + token;
    script.defer = true;
    document.body.appendChild(script)

    // 4️⃣ 插入样式
    const style = document.createElement("style")
    style.id = 'dify-style'
    style.innerHTML = `
        #dify-chatbot-bubble-button {
            background-color: #1C64F2 !important;
            position: fixed;
            bottom: 20px;
            right: 20px;
            cursor: grab;
            transition: all 0.3s ease;
        }
        #dify-chatbot-bubble-window {
            width: 24rem !important;
            height: 40rem !important;
            bottom: 120px !important;
            right: 80px !important;
        }
    `
    console.log(123);
    document.head.appendChild(style)

    // 5️⃣ 可选：拖拽 + 边缘吸附 + 自动缩回
    // setTimeout(makeBubbleButtonDraggable, 2000)
}

// 拖拽和边缘吸附函数
function makeBubbleButtonDraggable() {
    const button = document.querySelector('#dify-chatbot-bubble-button')
    if (!button) return

    let isDragging = false, offsetX, offsetY, autoHideTimer

    button.addEventListener('mousedown', e => {
        isDragging = true
        // 记录鼠标在按钮内部的偏移
        offsetX = e.clientX - button.offsetLeft
        offsetY = e.clientY - button.offsetTop
        button.style.cursor = 'grabbing'
        clearTimeout(autoHideTimer)
    })

    document.addEventListener('mousemove', e => {
        if (!isDragging) return
        // 鼠标在窗口中的位置减去按钮内部偏移，使按钮“跟随鼠标”
        button.style.left = e.clientX - offsetX + 'px'
        button.style.top = e.clientY - offsetY + 'px'
        button.style.right = 'auto'
        button.style.bottom = 'auto'
    })

    document.addEventListener('mouseup', () => {
        if (!isDragging) return
        isDragging = false
        button.style.cursor = 'grab'

        // 不再吸附到边缘
        autoHideTimer = setTimeout(() => {
            button.style.transform = 'scale(0.6)'
            button.style.opacity = '0.5'
        }, 5000)
    })

    button.addEventListener('mouseenter', () => {
        button.style.transform = 'scale(1)'
        button.style.opacity = '1'
        clearTimeout(autoHideTimer)
    })

    button.addEventListener('mouseleave', () => {
        autoHideTimer = setTimeout(() => {
            button.style.transform = 'scale(0.6)'
            button.style.opacity = '0.5'
        }, 5000)
    })
}

